import React from 'react';
import { Facebook, Instagram, Twitter, MapPin, Phone, Mail } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/sp4eZStgLM4H2n9wSDSXj9/ChatGPT_Image_Feb_1,_2026,_08_32_42_AM.png';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-300 py-16 border-t border-gray-800" data-id="element-80">
      <div className="container mx-auto px-4 md:px-6" data-id="element-81">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-82">
          {/* Brand Column */}
          <div data-id="element-83">
            <div className="mb-6" data-id="element-84">
              <img src={LOGO_URL} alt="CleenCo - Professional Cleaning Solutions" className="h-16 w-auto object-contain" data-id="element-85" />
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed" data-id="element-86">
              Professional, reliable, and trusted cleaning services for homes
              and businesses across Glasgow.
            </p>
            <div className="flex gap-4" data-id="element-87">
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-teal-600 hover:text-white transition-colors" data-id="element-88">
                <Facebook className="w-5 h-5" data-id="element-89" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-teal-600 hover:text-white transition-colors" data-id="element-90">
                <Instagram className="w-5 h-5" data-id="element-91" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-teal-600 hover:text-white transition-colors" data-id="element-92">
                <Twitter className="w-5 h-5" data-id="element-93" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-94">
            <h3 className="text-white font-bold text-lg mb-6" data-id="element-95">Quick Links</h3>
            <ul className="space-y-4" data-id="element-96">
              <li data-id="element-97">
                <a href="#home" className="hover:text-teal-400 transition-colors" data-id="element-98">
                  Home
                </a>
              </li>
              <li data-id="element-99">
                <a href="#services" className="hover:text-teal-400 transition-colors" data-id="element-100">
                  Services
                </a>
              </li>
              <li data-id="element-101">
                <a href="#why-us" className="hover:text-teal-400 transition-colors" data-id="element-102">
                  Why Choose Us
                </a>
              </li>
              <li data-id="element-103">
                <a href="#reviews" className="hover:text-teal-400 transition-colors" data-id="element-104">
                  Testimonials
                </a>
              </li>
              <li data-id="element-105">
                <a href="#contact" className="hover:text-teal-400 transition-colors" data-id="element-106">
                  Get a Quote
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-107">
            <h3 className="text-white font-bold text-lg mb-6" data-id="element-108">Our Services</h3>
            <ul className="space-y-4" data-id="element-109">
              <li data-id="element-110">
                <a href="#services" className="hover:text-teal-400 transition-colors" data-id="element-111">
                  End of Tenancy
                </a>
              </li>
              <li data-id="element-112">
                <a href="#services" className="hover:text-teal-400 transition-colors" data-id="element-113">
                  Office Cleaning
                </a>
              </li>
              <li data-id="element-114">
                <a href="#services" className="hover:text-teal-400 transition-colors" data-id="element-115">
                  Deep Cleaning
                </a>
              </li>
              <li data-id="element-116">
                <a href="#services" className="hover:text-teal-400 transition-colors" data-id="element-117">
                  Move In/Out
                </a>
              </li>
              <li data-id="element-118">
                <a href="#services" className="hover:text-teal-400 transition-colors" data-id="element-119">
                  Commercial Cleaning
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-120">
            <h3 className="text-white font-bold text-lg mb-6" data-id="element-121">Contact Us</h3>
            <ul className="space-y-4" data-id="element-122">
              <li className="flex items-start gap-3" data-id="element-123">
                <MapPin className="w-5 h-5 text-teal-500 mt-1" data-id="element-124" />
                <span data-id="element-125">
                  Glasgow, United Kingdom
                  <br data-id="element-126" />
                  Serving all surrounding areas
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-127">
                <Phone className="w-5 h-5 text-teal-500" data-id="element-128" />
                <a href="tel:07355854313" className="hover:text-teal-400 transition-colors" data-id="element-129">
                  07355 854313
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-130">
                <Mail className="w-5 h-5 text-teal-500" data-id="element-131" />
                <a href="mailto:Cleencoglasgow@gmail.com" className="hover:text-teal-400 transition-colors" data-id="element-132">
                  Cleencoglasgow@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500" data-id="element-133">
          <p data-id="element-134">© 2024 Cleen Co Glasgow. All rights reserved.</p>
          <div className="flex gap-6" data-id="element-135">
            <a href="#" className="hover:text-white transition-colors" data-id="element-136">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-137">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}